module.exports = __webpack_public_path__ + "static/media/img-servicos-cidades.1f5fd73a.png";